/* 渲染推荐 */
import React from 'react'
import Feed from 'Components/feed'
import { useFeedAd } from 'Components/hooks'
export interface IRecommend {
  id: string
  title: string
  author: {
    name: string
  }
  create_time: number
  video?: {
    duration: number
    cover_image_url: string
  }
  image_list?: [
    {
      url: string
    }
  ]
}

interface IProps {
  gid: string
  contentType: string
}

export default function Recommend({ gid, contentType }: IProps) {
  const feedAd = useFeedAd('motor_car', 'article') || []

  return (
    <section>
      <h3 className="title">热门推荐</h3>
      <Feed
        page="article"
        category="motor_car"
        gid={gid}
        feedAd={feedAd}
        contentType={contentType}
      />
      <style jsx>
        {`
          .title {
            position: relative;
            line-height: 25px;
            font-size: 24px;
            font-weight: 500;
            padding-bottom: 12px;
            border-bottom: 1px solid #e6e6e6;
          }
        `}
      </style>
    </section>
  )
}
